import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

import {
  activeCasesApi,
  aircraftStatusesApi,
  hubsResourceReportApi,
  newCasesApi,
  simpleStatisticsApi,
  surgeonsApi,
} from '../api';
import {
  blockSlice,
  notificationSlice,
  regionSlice,
  relationsSlice,
  sectionSlice,
  templateSlice,
  toolbarSlice,
  widgetInstanceSlice,
} from '../slices';
import { widgetManagerSlice } from '../widgetManager';

import { widgetManagerPersistConfig } from './persistConfig';

// Build base reducer
export const rootReducer = combineReducers({
  toolbar: toolbarSlice.reducer,
  widgetManager: persistReducer(
    widgetManagerPersistConfig,
    widgetManagerSlice.reducer,
  ),
  regions: regionSlice.reducer,
  sections: sectionSlice.reducer,
  blocks: blockSlice.reducer,
  widgetInstances: widgetInstanceSlice.reducer,
  relations: relationsSlice.reducer,
  notification: notificationSlice.reducer,
  template: templateSlice.reducer,
  [newCasesApi.reducerPath]: newCasesApi.reducer,
  [hubsResourceReportApi.reducerPath]: hubsResourceReportApi.reducer,
  [activeCasesApi.reducerPath]: activeCasesApi.reducer,
  [aircraftStatusesApi.reducerPath]: aircraftStatusesApi.reducer,
  [surgeonsApi.reducerPath]: surgeonsApi.reducer,
  [simpleStatisticsApi.reducerPath]: simpleStatisticsApi.reducer,
});

// Export RootState type - this can now be imported by slices without circular dependency
export type RootState = ReturnType<typeof rootReducer>;
